import isAuthenticationError from './is-authentication-error';
import { scaniaAnalyticsApiScopes, msalInstance } from '@/app/msal';

const getApiAccessToken = async (): Promise<string> => {
  const activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount) {
    return '';
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: scaniaAnalyticsApiScopes,
      account: activeAccount,
    });

    return response.accessToken;
  } catch (error: unknown) {
    if (isAuthenticationError(error)) {
      return '';
    }

    throw error;
  }
};

export default getApiAccessToken;
